__turbopack_context__.v({
  "root": "L7Phiq_root",
  "tableTd__fhlOq": "L7Phiq_tableTd__fhlOq",
  "tableTd__kN4Xg": "L7Phiq_tableTd__kN4Xg",
  "tableTd__si7In": "L7Phiq_tableTd__si7In",
  "tableTd__u6Ldr": "L7Phiq_tableTd__u6Ldr",
  "text__nQvc4": "L7Phiq_text__nQvc4",
  "text__nbnB": "L7Phiq_text__nbnB",
  "text__tsao3": "L7Phiq_text__tsao3",
  "text__zoAV": "L7Phiq_text__zoAV",
});
